import type { MarkupShape, MarkupTool } from './markupShapes.ts';

const TOOL_HINTS: Record<Exclude<MarkupTool, 'select'>, string> = {
    pen: 'Draw freehand',
    arrow: 'Drag from the tail to the tip · Shift for 45° steps',
    line: 'Drag to draw · Shift for 45° steps',
    rect: 'Drag to draw · Shift for a square',
    ellipse: 'Drag to draw · Shift for a circle',
    text: 'Click to add a label · Click a label to edit it'
};

const SELECTED_HINTS: Record<MarkupShape['kind'], string> = {
    text: 'Drag to move · Double-click to edit · Delete to remove',
    arrow: 'Drag to move · Drag an end to adjust · Delete to remove',
    line: 'Drag to move · Drag an end to adjust · Delete to remove',
    pen: 'Drag to move · Drag a handle to resize · Delete to remove',
    rect: 'Drag to move · Drag a handle to resize · Delete to remove',
    ellipse: 'Drag to move · Drag a handle to resize · Delete to remove'
};

export function markupHint(tool: MarkupTool, selectedKind: MarkupShape['kind'] | null): string {
    if (tool !== 'select') return TOOL_HINTS[tool];
    return selectedKind ? SELECTED_HINTS[selectedKind] : 'Click a mark to select it';
}
